import { ErrorBoundary } from '@/components/Rollbar';
import {
  useDefaultPagination,
  useInvoicesTransaction,
} from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/Detail/LeftContent/TransactionsDetail/hooks/useInvoicesTransaction';
import { useTranslation } from '@/i18n';

import { Wrapper } from '@/components/OpenFeature/Wrapper';
import { useInvoiceTransactionColumns } from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/Detail/LeftContent/TransactionsDetail/hooks/useInvoiceTransactionColumns';
import { FC, Suspense, memo, useMemo } from 'react';
import { ErrorTransactionsDetailTable } from './ErrorTransactionsDetailTable';
import { LoadingTransactionsDetailTable } from './LoadingTransactionsDetailTable';
import {
  InternalTableProps,
  TransactionsDetailTable,
} from './TransactionsDetailTable';

type InnerListProps = {
  reportId: string;
};

const InnerList: FC<InnerListProps> = memo(({ reportId }) => {
  const { data } = useInvoicesTransaction(reportId);
  const columns = useInvoiceTransactionColumns(reportId, data ?? []);

  const { t } = useTranslation();
  const pagination = useDefaultPagination();
  const table: InternalTableProps = useMemo(() => {
    return {
      data: data ?? [],
      columns: columns ?? [],
      emptyText: <>{t('transactions_detail_empty_message')}</>,
    };
  }, [data, columns, t]);

  return <TransactionsDetailTable table={table} pagination={pagination} />;
});
InnerList.displayName = 'InnerList';

type TransactionsDetailProps = {
  reportId: string;
};

export const TransactionsDetail: FC<TransactionsDetailProps> = memo(
  ({ reportId }) => {
    return (
      <Wrapper isProto={false}>
        <ErrorBoundary fallback={ErrorTransactionsDetailTable}>
          <Suspense fallback={<LoadingTransactionsDetailTable />}>
            <InnerList reportId={reportId} />
          </Suspense>
        </ErrorBoundary>
      </Wrapper>
    );
  }
);
TransactionsDetail.displayName = 'TransactionsDetail';
